import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { DocumentReader, DocumentProximityStatus } from 'src/app/modules/core/store/models';
import * as fromAuth from '../../../../../authentication/store/auth/auth.selectors';
import { Store } from '@ngrx/store';
import * as fromUserProfile from '../../../../store/user-profile';
import { take } from 'rxjs/operators';
import { CultureService } from 'src/app/modules/core/services/culture.service';

@Component({
    selector: 'app-distance-cell',
    templateUrl: './distance-cell.component.html',
    styleUrls: ['./distance-cell.component.scss'],
    standalone: false
})
export class DistanceCellComponent implements OnInit {
  value: any;
  unitAbbrv: string;

  constructor(private translate: TranslateService, private cultureService: CultureService,  private store: Store<fromUserProfile.State>) {}

  ngOnInit(): void {}

  agInit(params: any): void {
    const document = params.data;
    const field = params.schemaField;
    const reader = new DocumentReader(document);

    this.store
      .select(fromUserProfile.selectDistanceUnit)
      .pipe(take(1))
      .subscribe(unit => {
        let val = !!params.data ? reader.getFieldValue(field.systemName) : params.value;

        if (val === null || isNaN(val)) {
          this.value = '---';
          return;
        }

        if (val === DocumentProximityStatus.Pending || val === DocumentProximityStatus.Error) {
          const key = val === DocumentProximityStatus.Pending ? 'MANAGEMENT.DATASETS.CALCULATING' : 'MANAGEMENT.DATASETS.CALC-ERROR';
          this.value = this.translate.instant(key);
          return;
        }

        if (unit?.toLocaleLowerCase() === 'miles') {
          this.unitAbbrv = this.translate.instant(`UNITS.DISTANCE.${'MILES-ABBREVIATED-LOWER'}`);
          val = val / 1609;
        } else {
          this.unitAbbrv = this.translate.instant(`UNITS.DISTANCE.${'KILOMETERS-ABBREVIATED-LOWER'}`);
          val = val / 1000;
        }

        const format = field.settings?.format || '00[.]00';

        this.value = reader.formatNumber(val, format, this.cultureService);
      });
  }
}
